
import { Form, FormElement } from '05-ui-kit';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { formatPhoneAndMask } from '@artmizu/utils';
import { useContext } from '@nuxtjs/composition-api';
import { computed, ref, watch } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import Timer from '~/components/Timer/Timer.vue';
import { useTokenStore } from '~/store/token';
import { useUserStore } from '~/store/user';
import InputPhone from '~/components/InputPhone/InputPhone.vue';
interface ConfirmCode {
  loading?: boolean;
  success: boolean;
  error: boolean;
  response: Awaited<ReturnType<typeof context.$api.auth.sendConfirmCode>> | Awaited<ReturnType<typeof context.$api.auth.checkCodeAndLogin>>;
}
interface Props {
  sendConfirmCode: ConfirmCode;
  checkCodeAndLogin: ConfirmCode;
}
const __sfc_main = {};
__sfc_main.props = {
  sendConfirmCode: {
    key: "sendConfirmCode",
    required: true,
    type: null
  },
  checkCodeAndLogin: {
    key: "checkCodeAndLogin",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const {
    userAuth
  } = storeToRefs(useUserStore());
  const tokenStore = useTokenStore();
  const accessToken = computed(() => tokenStore.accessToken?.value);
  const context = useContext();
  const activeTypeBlock = ref<'phone' | 'code'>('phone');
  const phone = ref('');
  const code = ref('');
  const checkError = computed(() => {
    return props.checkCodeAndLogin?.response?.error ? props.checkCodeAndLogin.response.error?.description : null;
  });
  const sendConfirmCodeError = computed(() => props.sendConfirmCode?.error ? props.sendConfirmCode.response.error?.description : null);
  watch(() => props.sendConfirmCode.success, boolean => {
    if (boolean) activeTypeBlock.value = 'code';
  });
  function onInput(event: Event) {
    const currentTarget = (event.target as HTMLInputElement);
    if (currentTarget.value) phone.value = formatPhoneAndMask(currentTarget.value);
  }
  function onSubmit() {
    emit('submit', {
      phone: phone.value,
      short: true
    });
  }
  return {
    emit,
    userAuth,
    accessToken,
    activeTypeBlock,
    phone,
    code,
    checkError,
    sendConfirmCodeError,
    onInput,
    onSubmit
  };
};
__sfc_main.components = Object.assign({
  ValidationObserver,
  Form,
  Timer,
  FormElement,
  ValidationProvider,
  InputPhone
}, __sfc_main.components);
export default __sfc_main;
